<ev-accordion [evStyle]="'blue-05-gradient'" [borderStyle]="'border-style-blue'" (toggled)="expanderClicked()">
    <div header class="accordion-header">
        <div class="title">{{ accordionState()?.title() }}</div>

        @if (accordionState()?.counter()) {
        <span class="counter">{{ accordionState()?.counter() }}</span>
        }
    </div>

    <div body>
        @if (accordionState()?.expanded) { @if (accordionState()?.isLoading()) {
        <div class="loader">
            <ev-logo-loader variant="dots" width="24px" />
        </div>
        } @else { @if (!accordionState()?.hasInfo() && !accordionState()?.hasError()) {
        <ng-content></ng-content>
        } @else {
        <div class="info column-100">
            @if (accordionState()?.hasError) {
            <div class="icon error-icon"></div>
            <div class="infotext">{{ accordionState()?.errortext() || "Får ikke kontaktet server. Vent litt og prøv igjen." }}</div>
            } @else if (accordionState()?.hasInfo()) {
            <div class="icon info-icon"></div>
            <div class="infotext">{{ accordionState()?.infotext() || "Ingen " + accordionState().title() + " for denne eiendommen" }}</div>
            }
        </div>
        } } }
    </div>
</ev-accordion>
